import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router, } from '@angular/router';
import { AuthService } from '../shared/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../shared/auth.service";
export class AuthGuard {
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    canActivate(next, state) {
        return this.checkLogin();
    }
    canActivateChild(route, state) {
        return this.canActivate(route, state);
    }
    checkLogin() {
        const isLoggedIn = AuthService.isLoggedIn();
        if (!isLoggedIn) {
            this.router.navigate(['/']);
        }
        return isLoggedIn;
    }
}
AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService)); }, token: AuthGuard, providedIn: "root" });
